import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { useApi } from "../hooks/useApi";
const DATE_PRESETS = [
    { key: "ytd", label: "YTD", detail: "Jan 1 — today" },
    { key: "30d", label: "Last 30 days", detail: "Trailing 30 days" },
    { key: "90d", label: "Last 90 days", detail: "Trailing 90 days" },
    { key: "mtd", label: "MTD", detail: "Month to date" },
    { key: "qtd", label: "QTD", detail: "Quarter to date" },
];
function Popover({ open, onClose, anchorRef, children, }) {
    const ref = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        function onDoc(e) {
            if (ref.current && !ref.current.contains(e.target) &&
                anchorRef.current && !anchorRef.current.contains(e.target))
                onClose();
        }
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open, onClose, anchorRef]);
    if (!open)
        return null;
    return _jsx("div", { className: "popover", ref: ref, children: children });
}
function FilterDropdown({ label, valueLabel, options, value, onChange, multi }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    return (_jsxs("div", { className: "filter", style: { position: "relative" }, children: [_jsx("label", { children: label }), _jsxs("button", { ref: anchorRef, className: "control", "data-open": open, onClick: () => setOpen((v) => !v), type: "button", children: [_jsx("span", { children: valueLabel }), _jsx("span", { className: "chevron", children: "\u25BE" })] }), _jsx(Popover, { open: open, onClose: () => setOpen(false), anchorRef: anchorRef, children: options.map((opt) => {
                    const selected = multi
                        ? value.includes(opt.key)
                        : value === opt.key;
                    return (_jsxs("div", { className: `opt${selected ? " selected" : ""}`, onClick: () => {
                            if (multi) {
                                const arr = value;
                                const next = selected ? arr.filter((v) => v !== opt.key) : [...arr, opt.key];
                                onChange(next.length ? next : arr);
                            }
                            else {
                                onChange(opt.key);
                                setOpen(false);
                            }
                        }, children: [_jsx("span", { className: "check", children: selected ? "✓" : "" }), _jsxs("span", { style: { flex: 1 }, children: [_jsx("div", { children: opt.label }), opt.detail && (_jsx("div", { style: { fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--ink-3)", marginTop: 2 }, children: opt.detail }))] })] }, opt.key));
                }) })] }));
}
export default function FilterBar({ filters, setFilters }) {
    const { data: storeList } = useApi("/api/app/store-list");
    const storeOpts = [
        { key: "all", label: "All stores", detail: `${storeList?.length ?? 6} locations` },
        ...(storeList ?? []).map((s) => ({ key: s.store_id, label: s.store_name })),
    ];
    const datePreset = DATE_PRESETS.find((d) => d.key === filters.period) ?? DATE_PRESETS[0];
    const storeLabel = filters.stores.length === 0 || filters.stores.includes("all")
        ? "All stores"
        : filters.stores.length === 1
            ? (storeList?.find((s) => s.store_id === filters.stores[0])?.store_name ?? filters.stores[0])
            : `${filters.stores.length} stores`;
    return (_jsxs("div", { className: "filterbar", children: [_jsx(FilterDropdown, { label: "Range", value: filters.period, valueLabel: datePreset.label, options: DATE_PRESETS, onChange: (v) => setFilters({ ...filters, period: v }) }), _jsxs("div", { className: "filter", children: [_jsx("label", { children: "vs." }), _jsx("button", { className: "control", type: "button", disabled: true, style: { opacity: 0.6, cursor: "default" }, children: _jsx("span", { children: "Last year" }) })] }), _jsx(FilterDropdown, { label: "Store", value: filters.stores, valueLabel: storeLabel, options: storeOpts, multi: true, onChange: (v) => {
                    const arr = v;
                    const resolved = arr.includes("all") ? ["all"] : arr.filter((x) => x !== "all");
                    setFilters({ ...filters, stores: resolved.length ? resolved : ["all"] });
                } }), _jsxs("div", { className: "filter", children: [_jsx("label", { children: "Segment" }), _jsx("button", { className: "control", type: "button", disabled: true, style: { opacity: 0.6, cursor: "default" }, children: _jsx("span", { children: "All customers" }) })] }), _jsx("div", { className: "filter-spacer" }), _jsxs("div", { className: "filter-meta", children: [_jsx("span", { className: "pulse" }), _jsx("span", { children: "Live \u00B7 dbt marts" }), _jsx("span", { style: { color: "var(--ink-4)" }, children: "\u00B7" }), _jsx("span", { children: "as of May 20, 2026" })] })] }));
}
